import { AppDispatch } from "../store/store.ts";
import { loadingMessage, showErrorMessage, showLoading } from "../store/slices/alertsSlice.ts";
import * as api from "../api/serviceApi.ts";
import { setSchedules, setUsers} from "../store/slices/userSlice.ts";
import { CecyIA } from "../../src/utils/constants.js";

export const getUsersAction = (id: number) => (dispatch: AppDispatch) => {
  dispatch(showLoading(true));
  dispatch(loadingMessage('Cargando Usuario'));

  api.getUsers(id.toString()).then(result => {
    dispatch(setUsers(result));
  }).catch(() => {
    //content msg error
  }).finally(() => {
    //dispatch(showLoading(false));
  });
};

export const getScheduleAction = (id: number) => (dispatch: AppDispatch) => {
  dispatch(showLoading(true));
  dispatch(loadingMessage('Cargando horarios'));

  api.getSchedule(id.toString()).then(result => {
    dispatch(setSchedules(result));
  }).catch(() => {
    //content msg error
  }).finally(() => {
    dispatch(showLoading(false));
  });
};

export const updateSchedulesAction = (id: string, body: object) => async (dispatch: AppDispatch) =>  {
  dispatch(showLoading(true));
  dispatch(loadingMessage('Guardando horario'));

  await api.updateSchedule(id, body).then(result => {
    console.log("resultado", result)
    return result;
  }).catch((error) => {
    console.log("error")
    //content msg error
    dispatch(showErrorMessage(error));
  }).finally(() => {
    dispatch(showLoading(false));
  });
}
